import { barba, PageComponent } from "barba"
import EventBus from "js-event-bus"



/**
 * Local storage key into which store state
 */
const COMPARATOR_STATE_KEY = 'comparator-state'



/**
 * Event Bus
 *
 * DO NOT USE 'add' AND 'remove' EVENT TO
 * UPDATE DOM STATE! THIS COULD CAUSE
 * PROBLEM ACROSS MULTIPLE TABS OR WINDOW.
 * USE 'update' EVENT TO UPDATE DISPLAY.
 * 
 * event: 'add'
 * args: { id, title, image }
 * 
 * event: 'remove'
 * args: { id }
 * 
 * event: 'update'
 * args: [{ id, title, image }...]
 * 
 */
const EVENT_NAME_ADD = 'add'
const EVENT_NAME_REMOVE = 'remove'
const EVENT_NAME_UPDATE = 'update'
const eventBus = new EventBus();



/**
 * Central management of comparator state into local storage
 */
class ComparatorState {
    constructor() {
        eventBus.on(EVENT_NAME_ADD, obj => {
            let state = ComparatorState.getState()
            if (state.some(x => x.id === obj.id)) return
            state = [...state, obj]
            this.setState(state)
            eventBus.emit(EVENT_NAME_UPDATE, null, state)
        })

        eventBus.on(EVENT_NAME_REMOVE, obj => {
            let state = ComparatorState.getState().filter(x => x.id !== obj.id)
            this.setState(state)
            eventBus.emit(EVENT_NAME_UPDATE, null, state)
        })

        window.addEventListener('storage', e => {
            eventBus.emit(EVENT_NAME_UPDATE, null, ComparatorState.getState())
        })
    }

    setState(state) {
        localStorage.setItem(COMPARATOR_STATE_KEY, JSON.stringify(state))
    }

    static getState() {
        const storageItem = localStorage.getItem(COMPARATOR_STATE_KEY);
        return storageItem ? JSON.parse(storageItem) : []
    }
}
new ComparatorState()



/**
 * Compare partial component
 * Views/Partials/Components/Compare.cshtml
 */
const COMPARE_CLASS_ADD = 'compare--add'
const COMPARE_CLASS_ADDED = 'compare--added'
const COMPARE_CLASS_REMOVE = 'compare--delete'

class Compare {
    constructor({ node }) {
        this.node = node
        this.id = node.dataset.compareId
        this.title = node.dataset.compareTitle
        this.image = node.dataset.compareImage
        this.disableUpdate = false

        this.clickHandler = this.click.bind(this)
        this.updateHandler = this.update.bind(this)

        this.update(ComparatorState.getState())

        this.node.addEventListener("click", this.clickHandler)
        eventBus.on(EVENT_NAME_UPDATE, this.updateHandler)
    }

    click() {
        const obj = {
            id: this.id,
            title: this.title,
            image: this.image
        }

        // Add
        if (this.node.classList.contains(COMPARE_CLASS_ADD)) {
            this.disableUpdate = true

            eventBus.emit(EVENT_NAME_ADD, null, obj)

            this.node.classList.remove(COMPARE_CLASS_ADD)
            this.node.classList.add(COMPARE_CLASS_ADDED)

            setTimeout(() => {
                this.disableUpdate = false
                this.update(ComparatorState.getState())
            }, 2000)

            return
        }
        
        // Remove
        if (this.node.classList.contains(COMPARE_CLASS_REMOVE)) {
            this.disableUpdate = false
            eventBus.emit(EVENT_NAME_REMOVE, null, obj)
            return
        }
    }

    update(state) {
        if (this.disableUpdate) {
            return
        }

        this.node.classList.remove(COMPARE_CLASS_ADD, COMPARE_CLASS_ADDED, COMPARE_CLASS_REMOVE)

        if (state.some(x => x.id === this.id)) {
            this.node.classList.add(COMPARE_CLASS_REMOVE)
            return
        }

        this.node.classList.add(COMPARE_CLASS_ADD)
    }

    destroy() {
        this.node.removeEventListener("click", this.clickHandler)

        eventBus.detach(EVENT_NAME_UPDATE, this.updateHandler)

        delete this.node
        delete this.id
        delete this.title
        delete this.image
        delete this.disableUpdate

        delete this.clickHandler
        delete this.updateHandler
    }
}
new PageComponent(".compare", Compare)



/**
 * Update header comparator counter
 */
const HEADER_COMARATOR_COUNT_CLASS_BLINK = 'header-comparator__count--blink'
const HEADER_COMARATOR_COUNT_CLASS_HIDDEN = 'hidden'

class HeaderComparatorCount {
    constructor({ node }) {
        this.node = node
        this.count = null
        this.updateHandler = this.update.bind(this)
        this.animationendHandler = this.animationend.bind(this)

        this.update(ComparatorState.getState())

        this.node.addEventListener('animationend', this.animationendHandler)
        eventBus.on(EVENT_NAME_UPDATE, this.updateHandler)
    }

    update(state) {
        const count = state.length

        // Update text
        this.node.innerText = count

        // Visibility
        if (count <= 0) {
            this.node.classList.add(HEADER_COMARATOR_COUNT_CLASS_HIDDEN)
        } else {
            this.node.classList.remove(HEADER_COMARATOR_COUNT_CLASS_HIDDEN)
        }

        // Quit if initial (null), same or lower
        if (this.count === null || this.count >= count) {
            this.count = count
            return
        }

        // Blink animation not playing, do it
        if (!this.node.classList.contains(HEADER_COMARATOR_COUNT_CLASS_BLINK)) {
            this.node.classList.add(HEADER_COMARATOR_COUNT_CLASS_BLINK)
        }

        // Save count
        this.count = count
    }

    animationend() {
        this.node.classList.remove(HEADER_COMARATOR_COUNT_CLASS_BLINK)
    }

    destroy() {
        this.node.removeEventListener('animationend', this.animationendHandler)

        eventBus.detach(EVENT_NAME_UPDATE, this.updateHandler)

        delete this.node
        delete this.count
        delete this.updateHandler
        delete this.animationendHandler
    }
}
new PageComponent(".header-comparator__count", HeaderComparatorCount)



/**
 * Update header comparator dropdown
 */
class HeaderComparatorDropdown {
    constructor({ node }) {
        this.node = node
        this.empty = this.node.querySelector('.header-comparator__empty')
        this.enum = this.node.querySelector('.header-comparator__enum')
        this.list = this.node.querySelector('.header-comparator__list')
        this.template = this.list.querySelector('template')

        this.updateHandler = this.update.bind(this)
        this.update(ComparatorState.getState())
        eventBus.on(EVENT_NAME_UPDATE, this.updateHandler)
    }

    update(state) {
        // Is empty
        if (state.length <= 0) {
            this.empty.classList.remove('hidden')
            this.enum.classList.add('hidden')
            return
        }

        // Existing items element
        const items = [...this.list.querySelectorAll('.header-comparator__item')]

        // Array of ids in state and items
        const stateIds = state.map(x => x.id)
        const itemsIds = items.map(x => x.dataset.id)
        
        // Remove items not in state
        items.forEach(item => {
            if (stateIds.includes(item.dataset.id)) {
                return
            }
            item.parentNode.removeChild(item)
        })

        // Add new items
        state.forEach(obj => {
            if (itemsIds.includes(obj.id)) {
                return
            }
            
            let newItem = document.importNode(this.template.content, true)
            newItem.querySelectorAll('.header-comparator__item').forEach(x => x.dataset.id = obj.id)
            newItem.querySelectorAll('.header-comparator__item-img').forEach(x => { x.src = `${obj.image}?mode=max&bgcolor=FFFFFF&format=jpeg&width=160&height=128` })
            newItem.querySelectorAll('.header-comparator__item-title').forEach(x => x.innerText = obj.title)
            newItem.querySelectorAll('.header-comparator__item-delete').forEach(x => x.dataset.onClickComparatorRemove = obj.id)

            this.list.append(newItem)
            newItem = null
        })

        // Hide empty, show list
        this.empty.classList.add('hidden')
        this.enum.classList.remove('hidden')
    }

    destroy() {
        eventBus.detach(EVENT_NAME_UPDATE, this.updateHandler)

        delete this.node
        delete this.empty 
        delete this.enum
        delete this.list
        delete this.template

        delete this.updateHandler
    }
}
new PageComponent(".header-comparator__dropdown", HeaderComparatorDropdown)



/**
 * Mobile header visibility when item added to caparator
 */
class HeaderMobileVisibility {
    constructor({ node }) {
        this.node = node
        this.count = null
        this.updateHandler = this.update.bind(this)

        this.update(ComparatorState.getState())

        eventBus.on(EVENT_NAME_UPDATE, this.updateHandler)
    }

    update(state) {
        const count = state.length

        // Quit if initial (null), same or lower
        if (this.count === null || this.count >= count) {
            this.count = count
            return
        }

        // Update offset css custom properties to force reveal
        this.node.style.setProperty('--header-offset-y', '0px')

        // Save count
        this.count = count
    }

    destroy() {
        eventBus.detach(EVENT_NAME_UPDATE, this.updateHandler)

        delete this.node
        delete this.count
        delete this.updateHandler
    }
}
new PageComponent(".header", HeaderMobileVisibility)



/**
 * Update HREF of link
 */
class ComparatorHref {
    constructor({ node }) {
        this.node = node
        this.href = node.getAttribute('href').split('?')[0]
        this.updateHandler = this.update.bind(this)

        this.update(ComparatorState.getState())
        eventBus.on(EVENT_NAME_UPDATE, this.updateHandler)
    }

    update(state) {
        const ids = state.map(x => x.id)

        if (ids && ids.length > 0) {
            this.node.setAttribute('href', `${this.href}?id=${ids.join(',')}`)
            return
        }
        
        this.node.setAttribute('href', this.href)
    }

    destroy() {
        eventBus.detach(EVENT_NAME_UPDATE, this.updateHandler)

        delete this.node
        delete this.href
        delete this.updateHandler
    }
}
new PageComponent("a[href][data-comparator-href]", ComparatorHref)



/**
 * Data attribue applied to element, when clicked,
 * remove the ID from the state.
 * 
 * data-on-click-comparator-remove="ID"
 */
class OnClickComparatorRemove {
    constructor() {
        document.body.addEventListener(
            'click',
            e => {
                const node = e.target.closest('[data-on-click-comparator-remove]')
                if (!node) return
                // Hotfix, timeout solve problem with "is-within" (class IsWithinClass)
                setTimeout(() => {
                    eventBus.emit(EVENT_NAME_REMOVE, null, { id: node.dataset.onClickComparatorRemove })
                }, 0)
            }
        )
    }
}
new OnClickComparatorRemove()



/**
 * Add scroll-snap to compatible browsers
 */
class ComparatorScrollSnap {
    constructor({ node }) {
        if (navigator.userAgent.search("Firefox") === -1) {
            node.classList.add('comparator--snap')
        }
    }
    destroy() {}
}
new PageComponent(".comparator", ComparatorScrollSnap)



/**
 * Update HREF of link
 */
class ComparatorReload {
    constructor({ node }) {
        this.node = node
        this.href = location.href.split('?')[0]

        // This will be used with barba.go(url, trigger)
        // has the trigger argument (which will replace the history)
        this.trigger = document.createElement('a')
        this.trigger.dataset.barbaHistory = 'replace'

        this.updateHandler = this.update.bind(this)

        this.update(ComparatorState.getState())
        eventBus.on(EVENT_NAME_UPDATE, this.updateHandler)
    }

    update(state) {
        const currentParams = new URLSearchParams(document.location.search.substring(1))
        const currentIds = currentParams.get("id")
        const stateIds = state.map(x => x.id).join(',')

        if (currentIds === stateIds) {
            return
        }

        if (stateIds) {
            barba.go(`${this.href}?id=${stateIds}`, this.trigger)
            return
        }

        barba.history.add(this.href, this.trigger)
    }

    destroy() {
        eventBus.detach(EVENT_NAME_UPDATE, this.updateHandler)

        delete this.node
        delete this.href
        delete this.updateHandler
    }
}
new PageComponent(".comparator", ComparatorReload)
